import { useCallback } from 'react';
import { useAppStore } from '@/store';
import isBlobUrl from '@/utils/file/isBlobUrl';
import revokeBlobUrl from '@/utils/file/revokeBlobUrl';
import { InputType } from '@/types';

import type { IImageInput, IVideoInput } from '@/types';

type UpdateInput = (args: {
  id: string;
  value: Partial<IImageInput | IVideoInput>;
}) => void;

const useMediaRemove = (updateInput: UpdateInput) => {
  const handleMediaRemove = useCallback(
    (id: string) => {
      // Get current input to check if we need to revoke a blob URL
      const currentInput = useAppStore
        .getState()
        .inputs.find((i) => i.id === id);
      if (
        currentInput &&
        (currentInput.type === InputType.IMAGE ||
          currentInput.type === InputType.VIDEO) &&
        currentInput.src &&
        isBlobUrl(currentInput.src)
      ) {
        // Only revoke blob URLs, not CDN URLs (revokeBlobUrl checks isBlobUrl internally)
        revokeBlobUrl(currentInput.src);
      }

      updateInput({
        id,
        value: { src: undefined } as Partial<IImageInput | IVideoInput>,
      });
    },
    [updateInput]
  );

  return { handleMediaRemove };
};

export default useMediaRemove;
